import Vue from 'vue';
import dropWrapper from '@/components/global/drop-wrapper/index.vue';
import ConvertTable from '@/components/pages/bonus/components/tables/convert/index.vue';
import DepositTable from '@/components/pages/bonus/components/tables/deposit/index.vue';
import ConvertWidget from '@/components/pages/bonus/components/widgets/convert/index.vue';
import BalanceWidget from '@/components/pages/bonus/components/widgets/balance/index.vue';
import { RESPONSE_STATUS_CODES } from '@/constants/serverConstants';
import { getCorrectAmountHistoryItem } from '@/components/pages/bonus/helpers/index';
import moment from 'moment';
import BigNumber from 'bignumber.js';
import translation from '@/assets/rawData/i18n/bonusesPage.json';
import applyPageI18NMessages from '@/vue-utils/i18n';
import { tryRefresh, redirectToLogin } from '@/services/_helpers/interceptors';
import BonusAccrualWidget from '@/components/pages/bonus/components/widgets/bonusAccrualWidget/index.vue';
import { mapGetters } from 'vuex';
import ReqAfterKyc from './../spotPage/kyc-plugs/RegAfterKyc.vue';
const getAssetByTicker = (name, base) => name.slice(0, name.indexOf(base));
let bonusSocket = null;
let exchangeSocket = null;
export default Vue.extend({
    name: 'BonusesPage',
    data: () => ({
        bonusAssetsAmount: {
            loaded: false,
            error: false,
            data: {
                USDT: BigNumber(0),
                BNB: BigNumber(0),
                FDUSD: BigNumber(0),
                USDC: BigNumber(0),
                BTC: BigNumber(0)
            }
        },
        assetsPrice: {
            loaded: false,
            error: false,
            data: {
                BNB: BigNumber(-1),
                FDUSD: BigNumber(-1),
                USDC: BigNumber(-1),
                BTC: BigNumber(-1)
            }
        },
        autopay: {
            loaded: false,
            error: false,
            data: false
        },
        accrualBonus: {
            currentCoefficient: 0,
            paidCommission: 0,
            loaded: false,
            error: false
        },
        depositHistory: {
            loaded: false,
            error: false,
            data: [],
            totals: {
            // USDT: BigNumber(0),
            // FDUSD: BigNumber(0),
            // BNB: BigNumber(0),
            // USDC: BigNumber(0),
            // BTC: BigNumber(0)
            },
            hasNext: false,
            currentPage: 1,
            isNextPageLoaded: true
        },
        withdrawHistory: {
            loaded: false,
            error: false,
            data: [],
            totals: {
            // USDT: BigNumber(0),
            // FDUSD: BigNumber(0),
            // BNB: BigNumber(0),
            // USDC: BigNumber(0),
            // BTC: BigNumber(0)
            },
            hasNext: false,
            currentPage: 1,
            isNextPageLoaded: true,
            lastFilters: { currentPage: 1 }
        },
        connections: {
            bonusSocket: {
                silent: false,
                connected: false,
                error: false
            },
            exchangeSocket: {
                connected: false,
                error: false
            }
        },
        okxData: {
            future: 0,
            spot: 0,
            payment_sum: 0,
            uid: ''
        },
        okxDataError: false
    }),
    computed: Object.assign(Object.assign({}, mapGetters('user', ['extendedKycStatus'])), { isExtendedFailed() {
            return this.extendedKycStatus !== 'accepted' && this.extendedKycStatus !== null;
        },
        balanceWidgetLoadingState() {
            const isConnected = this.connections.bonusSocket.connected && this.connections.exchangeSocket.connected;
            const isConnectionError = this.connections.bonusSocket.error || this.connections.exchangeSocket.error;
            return {
                isError: isConnectionError || this.bonusAssetsAmount.error || this.assetsPrice.error || this.autopay.error,
                isRetry: (!isConnected || !this.bonusAssetsAmount.loaded || !this.assetsPrice.loaded) && !this.connections.bonusSocket.silent
            };
        },
        convertWidgetLoadingState() {
            const isConnected = this.connections.bonusSocket.connected && this.connections.exchangeSocket.connected;
            const isConnectionError = this.connections.bonusSocket.error || this.connections.exchangeSocket.error;
            return {
                isError: isConnectionError || this.bonusAssetsAmount.error || this.assetsPrice.error,
                isRetry: (!isConnected || !this.bonusAssetsAmount.loaded || !this.assetsPrice.loaded) && !this.connections.bonusSocket.silent
            };
        },
        accrualBonusWidgetLoadingState() {
            const isConnected = this.connections.bonusSocket.connected;
            const isConnectionError = this.connections.bonusSocket.error;
            return {
                isError: isConnectionError || this.accrualBonus.error,
                isRetry: (!isConnected || !this.accrualBonus.loaded) && !this.connections.bonusSocket.silent
            };
        },
        depositTableState() {
            const isConnected = this.connections.bonusSocket.connected && this.connections.exchangeSocket.connected;
            const isConnectionError = this.connections.bonusSocket.error || this.connections.exchangeSocket.error;
            return {
                isError: isConnectionError || this.depositHistory.error || this.assetsPrice.error,
                isRetry: (!isConnected || !this.depositHistory.loaded || !this.assetsPrice.loaded) && !this.connections.bonusSocket.silent
            };
        },
        withdrawTableState() {
            const isConnected = this.connections.bonusSocket.connected && this.connections.exchangeSocket.connected;
            const isConnectionError = this.connections.bonusSocket.error || this.connections.exchangeSocket.error;
            return {
                isError: isConnectionError || this.withdrawHistory.error || this.assetsPrice.error,
                isRetry: (!isConnected || !this.withdrawHistory.loaded || !this.assetsPrice.loaded) && !this.connections.bonusSocket.silent
            };
        },
        faqPageUrl() {
            const urlObject = new URL('/bonus-rules', window.location.origin);
            return urlObject.toString();
        } }),
    methods: {
        onRetry(source) {
            this.connections.bonusSocket.silent = false;
            const isHistoryError = this.depositHistory.error || this.withdrawHistory.error;
            const isWidgetError = this.autopay.error || this.bonusAssetsAmount.error;
            if (this.connections.bonusSocket.error || isWidgetError || isHistoryError) {
                this.connectBonusSocket();
            }
            if (this.connections.exchangeSocket.error || this.assetsPrice.error) {
                this.connectExchangeSocket();
            }
        },
        onAutopayChange(value) {
            if (!bonusSocket) {
                this.connections.bonusSocket.error = true;
                return;
            }
            this.autopay.loaded = false;
            bonusSocket.send(JSON.stringify({
                action: 'autopay_change',
                payload: {
                    autopay: !value
                }
            }));
        },
        onConvert(v) {
            const { amount, asset } = v;
            if (!bonusSocket) {
                this.connections.bonusSocket.error = true;
                return;
            }
            bonusSocket.send(JSON.stringify({
                action: 'bonuses_pay',
                payload: {
                    asset,
                    amount: amount.toNumber()
                }
            }));
        },
        onHistoryLoad(filters, historyType) {
            if (!bonusSocket) {
                this.connections.bonusSocket.error = true;
                return;
            }
            const payload = {
                page: filters.currentPage
            };
            if (filters.dateFrom && filters.dateTo) {
                payload.date_from = moment(filters.dateFrom).format('DD.MM.YYYY');
                payload.date_to = moment(filters.dateTo).format('DD.MM.YYYY');
            }
            if (filters.area && filters.area.length > 0) {
                payload.area = filters.area;
            }
            if (filters.asset.length > 0) {
                payload.asset = filters.asset;
            }
            if (historyType === 'deposit') {
                if (filters.currentPage === 1) {
                    this.depositHistory.loaded = false;
                }
                else {
                    this.depositHistory.isNextPageLoaded = false;
                }
            }
            if (historyType === 'withdraw') {
                this.withdrawHistory.lastFilters = Object.assign(Object.assign({}, filters), { currentPage: 1 });
                if (filters.currentPage === 1) {
                    this.withdrawHistory.loaded = false;
                }
                else {
                    this.withdrawHistory.isNextPageLoaded = false;
                }
            }
            const sendMessage = () => {
                if (bonusSocket) {
                    bonusSocket.send(JSON.stringify({
                        action: 'bonuses_history',
                        payload: Object.assign({ history_type: historyType, sort_by: ['-created_at'] }, payload)
                    }));
                }
            };
            if (this.connections.bonusSocket.connected) {
                sendMessage();
            }
            else {
                bonusSocket.addEventListener('open', sendMessage);
            }
        },
        connectBonusSocket() {
            this.closeBonusSocket();
            bonusSocket = new WebSocket(`wss://${document.location.hostname}/ws/bonuses/`);
            bonusSocket.onmessage = (e) => {
                const message = JSON.parse(e.data);
                const { payload, status, action } = message;
                if (action === undefined && status === RESPONSE_STATUS_CODES.UNAUTHORIZED) {
                    tryRefresh().then(res => {
                        if (!res) {
                            redirectToLogin();
                        }
                        this.connections.bonusSocket.connected = true;
                    });
                    this.connections.bonusSocket.error = true;
                    this.connections.bonusSocket.connected = false;
                    return;
                }
                switch (action) {
                    case 'bonuses_coef':
                        if (status === RESPONSE_STATUS_CODES.OK) {
                            // eslint-disable-next-line
                            const { currentCoefficient, paidCommission } = payload;
                            this.accrualBonus.currentCoefficient = currentCoefficient;
                            this.accrualBonus.paidCommission = paidCommission;
                        }
                        else {
                            this.accrualBonus.error = true;
                        }
                        this.accrualBonus.loaded = true;
                        break;
                    case 'bonuses_config':
                        if (status === RESPONSE_STATUS_CODES.OK) {
                            this.autopay.data = payload.autopay;
                        }
                        else {
                            this.autopay.error = true;
                        }
                        this.autopay.loaded = true;
                        break;
                    case 'bonuses_balance':
                        if (status === RESPONSE_STATUS_CODES.OK) {
                            this.bonusAssetsAmount.data.USDT = this.NS(payload.USDT);
                            this.bonusAssetsAmount.data.BNB = this.NS(payload.BNB);
                            this.bonusAssetsAmount.data.FDUSD = this.NS(payload.FDUSD);
                            this.bonusAssetsAmount.data.USDC = this.NS(payload.USDC);
                            this.bonusAssetsAmount.data.BTC = this.NS(payload.BTC);
                        }
                        else {
                            this.bonusAssetsAmount.error = true;
                        }
                        this.bonusAssetsAmount.loaded = true;
                        break;
                    case 'autopay_change':
                        if (status === RESPONSE_STATUS_CODES.OK) {
                            this.autopay.data = payload.autopay;
                        }
                        else {
                            this.autopay.data = Boolean(this.autopay.data);
                            this.autopay.error = true;
                        }
                        this.autopay.loaded = true;
                        break;
                    case 'bonuses_history':
                        if (status === RESPONSE_STATUS_CODES.OK) {
                            const newHistoryItems = payload.data.map(getCorrectAmountHistoryItem);
                            if (payload.history_type === 'deposit') {
                                if (payload.current_page_number === 1) {
                                    this.depositHistory.data = newHistoryItems;
                                }
                                else {
                                    this.depositHistory.data = this.depositHistory.data.concat(newHistoryItems);
                                }
                                this.depositHistory.hasNext = payload.has_next;
                                this.depositHistory.currentPage = payload.current_page_number;
                                this.depositHistory.error = false;
                                this.depositHistory.loaded = true;
                                this.depositHistory.isNextPageLoaded = true;
                                const totalsAssets = Object.keys(payload.sum_rebate);
                                totalsAssets.forEach(asset => {
                                    this.$set(this.depositHistory.totals, asset, BigNumber(payload.sum_rebate[asset]));
                                });
                            }
                            if (payload.history_type === 'withdraw') {
                                if (payload.current_page_number === 1) {
                                    this.withdrawHistory.data = newHistoryItems;
                                }
                                else {
                                    this.withdrawHistory.data = this.withdrawHistory.data.concat(newHistoryItems);
                                }
                                this.withdrawHistory.hasNext = payload.has_next;
                                this.withdrawHistory.currentPage = payload.current_page_number;
                                this.withdrawHistory.error = false;
                                this.withdrawHistory.loaded = true;
                                this.withdrawHistory.isNextPageLoaded = true;
                                const totalsAssets = Object.keys(payload.sum_rebate);
                                totalsAssets.forEach(asset => {
                                    this.$set(this.withdrawHistory.totals, asset, BigNumber(payload.sum_rebate[asset]).multipliedBy(-1));
                                });
                            }
                        }
                        else {
                            if (payload.history_type === 'deposit') {
                                this.depositHistory.loaded = true;
                                this.depositHistory.error = true;
                            }
                            else if (payload.history_type === 'withdraw') {
                                this.withdrawHistory.loaded = true;
                                this.withdrawHistory.error = true;
                            }
                            else {
                                this.depositHistory.error = true;
                                this.depositHistory.loaded = true;
                                this.withdrawHistory.loaded = true;
                                this.withdrawHistory.error = true;
                            }
                        }
                        break;
                    case 'bonuses_pay':
                        if (status === RESPONSE_STATUS_CODES.CONTINUE) {
                            this.$store.dispatch('alertsBus/openAlert', {
                                title: this.$t('bonusesPage.popups.titles.convert'),
                                type: 'info',
                                autoDelete: true,
                                content: payload.message
                            });
                        }
                        else if (status === RESPONSE_STATUS_CODES.OK) {
                            if (bonusSocket)
                                bonusSocket.send('{"action":"bonuses_balance"}');
                            this.onHistoryLoad(this.withdrawHistory.lastFilters, 'withdraw');
                            this.$store.dispatch('alertsBus/openAlert', {
                                title: this.$t('bonusesPage.popups.titles.success'),
                                type: 'success',
                                autoDelete: true,
                                content: payload.message
                            });
                        }
                        else {
                            if (bonusSocket)
                                bonusSocket.send('{"action":"bonuses_balance"}');
                            this.$store.dispatch('alertsBus/openAlert', {
                                title: this.$t('bonusesPage.popups.titles.error'),
                                type: 'error',
                                autoDelete: true,
                                content: payload[0]
                            });
                        }
                        break;
                    case 'okx_data':
                        this.okxDataError = status !== RESPONSE_STATUS_CODES.OK;
                        if (status === RESPONSE_STATUS_CODES.OK)
                            this.okxData = payload;
                        break;
                }
            };
            bonusSocket.onopen = () => {
                if (bonusSocket) {
                    this.autopay.loaded = false;
                    this.bonusAssetsAmount.loaded = false;
                    this.depositHistory.loaded = false;
                    this.withdrawHistory.loaded = false;
                    this.accrualBonus.loaded = false;
                    this.connections.bonusSocket.connected = true;
                    bonusSocket.send('{"action":"bonuses_config"}');
                    bonusSocket.send('{"action":"bonuses_balance"}');
                    bonusSocket.send('{"action":"bonuses_coef"}');
                    bonusSocket.send('{"action":"okx_data"}');
                }
            };
            bonusSocket.onerror = () => {
                this.connections.bonusSocket.error = true;
                this.connections.bonusSocket.silent = false;
            };
            bonusSocket.onclose = () => {
                if (this.connections.bonusSocket.error === true) {
                    this.autopay.loaded = true;
                    this.bonusAssetsAmount.loaded = true;
                    this.depositHistory.loaded = true;
                    this.withdrawHistory.loaded = true;
                }
                else {
                    this.connections.bonusSocket.connected = false;
                    this.connections.bonusSocket.silent = true;
                    this.connectBonusSocket();
                }
            };
        },
        connectExchangeSocket() {
            this.closeExchangeSocket();
            exchangeSocket = new WebSocket('wss://stream.binance.com:9443/stream?streams=bnbusdt@ticker_1h/fdusdusdt@ticker_1h/usdcusdt@ticker_1h/btcusdt@ticker_1h');
            exchangeSocket.onmessage = (e) => {
                const marketData = JSON.parse(e.data).data;
                const asset = getAssetByTicker(marketData.s, 'USDT');
                this.assetsPrice.data[asset] = this.NS(marketData.w);
                const isAllPricesLoaded = Object.values(this.assetsPrice.data).every(price => price !== '-1');
                if (isAllPricesLoaded) {
                    this.assetsPrice.loaded = true;
                }
            };
            exchangeSocket.onopen = () => {
                this.assetsPrice.loaded = false;
                this.connections.exchangeSocket.connected = true;
            };
            exchangeSocket.onerror = () => {
                this.connections.exchangeSocket.error = true;
            };
            exchangeSocket.onclose = () => {
                this.connections.exchangeSocket.connected = false;
                this.connectExchangeSocket();
            };
        },
        closeBonusSocket() {
            this.connections.bonusSocket.connected = false;
            this.connections.bonusSocket.error = false;
            this.autopay.error = false;
            this.bonusAssetsAmount.error = false;
            this.accrualBonus.error = false;
            if (bonusSocket) {
                bonusSocket.onclose = null;
                bonusSocket.close();
                bonusSocket = null;
            }
        },
        closeExchangeSocket() {
            this.connections.exchangeSocket.connected = false;
            this.connections.exchangeSocket.error = false;
            this.assetsPrice.error = false;
            this.assetsPrice.data.BNB = BigNumber(-1);
            this.assetsPrice.data.FDUSD = BigNumber(-1);
            this.assetsPrice.data.USDC = BigNumber(-1);
            this.assetsPrice.data.BTC = BigNumber(-1);
            if (exchangeSocket) {
                exchangeSocket.onclose = null;
                exchangeSocket.close();
                exchangeSocket = null;
            }
        }
    },
    created() {
        applyPageI18NMessages(this, 'bonusesPage', translation);
        this.connectBonusSocket();
        this.connectExchangeSocket();
    },
    beforeRouteLeave(from, to, next) {
        this.closeBonusSocket();
        this.closeExchangeSocket();
        next();
    },
    beforeDestroy() {
        this.closeBonusSocket();
        this.closeExchangeSocket();
    },
    components: {
        dropWrapper,
        ConvertTable,
        DepositTable,
        ConvertWidget,
        BalanceWidget,
        BonusAccrualWidget,
        ReqAfterKyc
    }
});
